<template>
    <header class="header">
        <x-header
            color="primary"
            :isMenuOpen="menuOpen"
            :back-button="showBackButton"
            @menuTriggerClick="menuOpen = !menuOpen"
            @backButtonClick="backButton"
        >
            <template v-slot:middle>
                <router-link :to="dashboardLink" class="logo">
                    <img src="/assets/img/howden-logo.svg" alt="Howden Logo" >
                </router-link>
            </template>

            <template v-slot:right>
                <notifications-icon />
            </template>
        </x-header>

        <navigation-overlay :menuOpen="menuOpen" @closeNav="closeNav"/>
    </header>
</template>

<script>
    import CircleIcon from '~/components/Shared/UIComponents/CircleIcon';
    import NavigationOverlay from '~/components/Shared/Partials/NavigationOverlay.vue';
    import NotificationsMixin from '~/mixins/notifications';
    import NotificationsIcon from "../UIComponents/Notifications/NotificationsIcon";

    export default {
        name: 'NavBar',
        components: {
            CircleIcon,
            NavigationOverlay,
            NotificationsIcon
        },
        mixins: [NotificationsMixin],
        props: ['info', 'notifications'],
        data: function () {
            return {
                user: [],
                menuOpen: false
            }
        },
        computed: {
            dashboardLink() {
                return this.$root.user.company && this.$root.user.company.company_type === 'insured' ? '/insured/dashboard/' : '/agent/dashboard/';
            },
            showBackButton() {
                return !['broker-dashboard', 'insured-dashboard'].includes(this.$route.name);
            }
        },
        methods: {
            toggleMenu() {
                this.menuOpen = !this.menuOpen;
            },
            closeNav() {
                this.menuOpen = false;
            },
            backButton() {
                this.$router.go(-1);
            }
        },
    }
</script>

<style lang="scss" scoped>
.header {
    .x-header {
        position: sticky;
        top: 0;
        z-index: 5;

        ::v-deep .container {
            padding: 0 1%;
        }

        :deep(.x-header__middle) {
            height: 100%;
            padding: 10px 15px;
        }
    }
}
</style>
